import { NetworkInterface } from './network';

export class NetworkWeb implements NetworkInterface {
  private _isOnline = true;
  private callbacks: ((isOnline: boolean) => void)[] = [];

  constructor() {
    this._isOnline = navigator.onLine;

    window.addEventListener(`online`, () => {
      if (this._isOnline) {
        return;
      }
      this._isOnline = true;
      this.callbacks.forEach((callback) => callback(this._isOnline));
    });
    window.addEventListener(`offline`, () => {
      if (!this._isOnline) {
        return;
      }
      this._isOnline = false;
      this.callbacks.forEach((callback) => callback(this._isOnline));
    });
  }

  addCallback(callback: (isOnline: boolean) => void): void {
    this.callbacks.push(callback);
  }

  isOnline(): boolean {
    return this._isOnline;
  }

  removeListeners(): void {
    window.removeEventListener(`online`, () => {});
    window.removeEventListener(`offline`, () => {});
  }
}
